import { Plus } from 'lucide-react'
import { classNames } from '@/utils/classNames'

interface CreateCollectionListItemProps {
    onClick: (e: React.MouseEvent) => void
    text?: string
    className?: string
}

/**
 * Inline list item button for creating a new collection.
 * Used in desktop dropdown panels.
 * Includes hover state for desktop UX.
 */
export function CreateCollectionListItem({
    onClick,
    text = 'Create new collection',
    className,
}: CreateCollectionListItemProps) {
    return (
        <div className="px-2">
            <div
                className={classNames(
                    'group flex cursor-pointer items-center gap-3 rounded-xl px-2 py-2 hover:bg-gray-100 transition-colors',
                    className
                )}
                onClick={onClick}
            >
                <div className="flex h-8 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-100">
                    <Plus size={16} className="text-gray-600" />
                </div>
                <div className="min-w-0">
                    <p className="text-sm font-medium text-black">{text}</p>
                </div>
            </div>
        </div>
    )
}

